module.exports = __webpack_public_path__ + "static/media/amex.00c2ff62.png";